module.exports = __webpack_public_path__ + "static/media/Group 37403.d25587a1.svg";